import React, { useMemo, useCallback } from 'react';
import { FilterSelect, FilterSelectOption } from '../inputs/filter-select';
import { useServerSideDatatable } from '../serverside-datatable';
import { Sprite } from '../sprite';
import { Link, useNavigate } from 'react-router-dom';

interface Props {}

export const EventFilterer: React.FC<Props> = () => {
  const {
    searchBarPlaceholder,
    currentPage,
    setSearchTerm,
    setFilterByValue,
    filterByValue,
    setFilterByField,
    query,
  } = useServerSideDatatable();

  const navigate = useNavigate();
  const navigateToCreate = useCallback(() => {
    navigate(`/events/new`);
  }, [navigate]);

  return (
    <div className="flex flex-row mb-4">
      <div className="flex-1">
        <div className="relative">
          <div className="absolute top-0 pl-[14.5px] h-full flex flex-col justify-center z-[2] pointer-events-none">
            <Sprite
              name="icon-search"
              className="w-[20px] h-[20px] text-gray fill-gray"
            />
          </div>
          <input
            type="text"
            className="border border-gray-medium rounded-md pl-[40px] py-2 pr-2 placeholder:text-gray relative z-[1] w-full bg-white"
            placeholder={searchBarPlaceholder}
            onChange={event => setSearchTerm(event.currentTarget.value)}
          />
        </div>
      </div>
      <div className="flex-1 flex flex-row justify-end pl-16">
        <div className="pl-3">
          <button
            type="button"
            onClick={() => query({ page: currentPage })}
            className="px-4 py-2 border-[2px] border-white bg-white shadow-[0px_1px_1px_rgba(0,0,0,0.06)] active:shadow-none rounded-[5px] font-semibold text-blue">
            Refresh
          </button>
          <button
            type="button"
            onClick={() => {
              navigateToCreate();
            }}
            className="ml-2 mt-[-3px] px-4 py-2 border-[2px] border-blue bg-blue text-white shadow-[0px_1px_1px_rgba(0,0,0,0.06)] active:shadow-none rounded-[5px] font-semibold inline-flex items-center space-x-2 align-middle">
            <Sprite
              name="icon-create"
              className="w-[20px] h-[20px] text-white fill-white"
            />
            <span>Create Event</span>
          </button>
        </div>
      </div>
    </div>
  );
};
